import React from 'react';
import Button from '@mui/material/Button'
function UpdateUser() {
  return <div>
      <Button>Update user</Button>
  </div>;
}

export default UpdateUser;
